var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ActionTypes } from './actions';
export var initialState = {
    isTealiumReady: false,
    eventQueue: [],
};
export var analytics = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case ActionTypes.INIT_ANALYTICS:
            return __assign(__assign({}, state), { isTealiumReady: true });
        case ActionTypes.ADD_TO_QUEUE:
            return __assign(__assign({}, state), { eventQueue: __spreadArray(__spreadArray([], state.eventQueue, true), [action.payload], false) });
        case ActionTypes.CLEAR_QUEUE:
            return __assign(__assign({}, state), { eventQueue: [] });
        default:
            return state;
    }
};
